import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CusLink from './CusLink';
import { getOnlyData } from '../../utils';
import dayjs from 'dayjs';
import ShowContainer from './ShowContainer';
import { ENUM_DATE_PRESENT_LABEL } from '../../enums/enums';

export default function DatePreset({
  setStartDate,
  setEndDate,
  fontSize = 12,
  onlyDate,
  setDateLabel
}) {
  const { t } = useTranslation();

  const currentWeekStart = dayjs().locale('ru').startOf('week');

  const onDateClick = ({ start, end }, label) => {
    const startTime = onlyDate ? '' : '00:00:00';
    const endTime = onlyDate ? '' : '23:59:59';

    const startDate = getOnlyData(start, startTime);
    const endDate = getOnlyData(end, endTime);
    setStartDate(startDate);
    setEndDate(endDate);
    setDateLabel?.(label);
  };

  const data = [
    {
      label: ENUM_DATE_PRESENT_LABEL.today,
      id: 'today',
      value: { start: dayjs(), end: dayjs() }
    },
    {
      label: ENUM_DATE_PRESENT_LABEL.yesterday,
      id: 'yesterday',
      value: {
        start: dayjs().subtract(1, 'day'),
        end: dayjs().subtract(1, 'day')
      }
    },
    {
      label: ENUM_DATE_PRESENT_LABEL.currentWeek,
      id: 'current_week',
      value: {
        start: currentWeekStart,
        end: dayjs()
      }
    },
    {
      label: ENUM_DATE_PRESENT_LABEL.lastWeek,
      id: 'last_week',
      value: {
        start: currentWeekStart.subtract(7, 'day'),
        end: currentWeekStart.subtract(1, 'day')
      }
    },
    {
      label: ENUM_DATE_PRESENT_LABEL.currentMonth,
      id: 'current_month',
      value: {
        start: dayjs().startOf('month'),
        end: dayjs()
      }
    },
    {
      label: ENUM_DATE_PRESENT_LABEL.lastMonth,
      id: 'last_month',
      value: {
        start: dayjs().subtract(1, 'month').startOf('month'),
        end: dayjs().subtract(1, 'month').endOf('month')
      }
    },
    {
      label: ENUM_DATE_PRESENT_LABEL.currentYear,
      id: 'current_year',
      value: {
        start: dayjs().startOf('year'),
        end: dayjs()
      }
    },
    {
      label: ENUM_DATE_PRESENT_LABEL.lastYear,
      id: 'last_year',
      value: {
        start: dayjs().subtract(1, 'year').startOf('year'),
        end: dayjs().subtract(1, 'year').endOf('year')
      }
    }
  ];

  return (
    <Stack gap={0.5} direction={'row'} flexWrap={'wrap'}>
      {data.map((item, index) => (
        <Stack key={item.id} direction={'row'} gap={0.5}>
          <CusLink
            fontSize={fontSize}
            key={item.id}
            linkComponent="button"
            text={item.label}
            onClick={() => onDateClick(item.value, item.label)}
          />

          <Typography>
            <ShowContainer condition={data.length - 1 !== index}>|</ShowContainer>
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
}
